import {getLocaleCode} from 'src/utils/format-number';
import moment from 'moment';

const formatFileSize = (kilobytes: number) => {
  if (kilobytes === 0) return '0 KB';
  const sizes = ['KB', 'MB', 'GB', 'TB', 'PB'];
  const index = Math.floor(Math.log(kilobytes) / Math.log(1024));
  const formattedSize = parseFloat(
    (kilobytes / Math.pow(1024, index)).toFixed(2)
  );
  return `${formattedSize} ${sizes[index]}`;
};

const deepCopy = (obj: any) => {
  return JSON.parse(JSON.stringify(obj));
};

const fCurrency = (value: any) => {
  const {code, currency} = getLocaleCode();

  // Check for null, undefined, or non-numeric input
  if (value == null || isNaN(Number(value))) return '';

  // Convert the input value to a number and round it to 2 decimal places
  const roundedValue = Math.round(Number(value) * 100) / 100;

  // Use Intl.NumberFormat for currency formatting
  const fm = new Intl.NumberFormat(code, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2, // Ensure 2 decimal places
    maximumFractionDigits: 2
  }).format(roundedValue);

  return fm;
};

const getCurrentMonthStartDate = () => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), 1);
};

const getCurrentMonthEndDate = () => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth() + 1, 0);
};

const getGridSx = (gridProps: any) => {
  const {theme, APP, checkboxColor, gridHeight, horizontalScroll, minHeight} =
    gridProps;
  return {
    backgroundColor: `${APP.PALETTE.COMMON.WHITE}`,
    '& .MuiTablePagination-displayedRows': {
      display: 'none'
    },
    '& .MuiPagination-ul': {
      flexWrap: 'nowrap'
    },
    '& .MuiDataGrid-row': {
      border: '1px solid lightgray',
      borderTopWidth: '0px',
      width: 'calc(100% - 2px)'
    },
    '& .MuiDataGrid-columnHeaders': {
      border: '1px solid lightgray',
      backgroundColor: `${theme.palette.grey[300]}`,
      borderBottomColor: `${theme.palette.primary.lighter}`,
      borderBottomWidth: '1px'
    },
    '& .MuiDataGrid-columnHeader--moving': {
      backgroundColor: `${APP.PALETTE.DATA_GRID.HEADER}`
    },
    '& .AbnormalFlagText': {
      color: `${APP.PALETTE.ABNORMAL_FLAG.TEXT}`,
      fontWeight: 'bold !important'
    },
    '& .css-87hgir-MuiTypography-root': {
      fontWeight: 'unset'
    },
    '& .css-11d09j8-MuiButtonBase-root-MuiCheckbox-root.Mui-checked': {
      color: checkboxColor || `${theme.palette.primary.lighter}`
    },
    '& .MuiDataGrid-virtualScroller': {
      minHeight: minHeight || '70px',
      // maxHeight: gridHeight ?? '50vh',
      overflowY: 'hidden !important',
      scrollBehavior: 'smooth',
      overflow: horizontalScroll ? 'auto' : 'visible !important'
    },
    '& .MuiDataGrid-footerContainer': {
      marginBottom: '1rem'
    },
    '& .MuiDataGrid-detailPanel': {
      border: '1px solid lightgray'
    },
    '& .MuiDataGrid-pinnedRowsRenderZone': {
      fontWeight: 'bolder'
    },
    // '.autopost-grid-editable-cell': {
    //   backgroundColor: '#e0f7fa',
    //   color: '#004d40'
    // },
    px: 3,
    pr: 0,
    pl: 0
  };
};

const isValidDate = (value: any) => {
  try {
    const parsedDate = moment(value, moment.ISO_8601, true);
    if (!parsedDate.isValid()) {
      return false;
    }
    const year = parsedDate.year();
    return year >= 1900 && year <= 9999;
  } catch (e) {
    return false;
  }
};

const getApplicationName = () => {
  return localStorage.getItem('applicationName');
};

export const shadowBoxSx = {
  width: '100%',
  boxShadow: 5,
  margin: '20px 0',
  borderRadius: '8px',
  bgcolor: 'white',
  p: 2,
  overflow: 'auto',
  padding: '24px'
};

export {
  formatFileSize,
  deepCopy,
  fCurrency,
  getCurrentMonthStartDate,
  getCurrentMonthEndDate,
  getGridSx,
  isValidDate,
  getApplicationName
};
